export default __webpack_public_path__ + "static/media/infant-patient-room.769cd97c.jpg";